<template>
  <div id="userPay">
    <div class="el-tuis-cons">
      <div class="tit-rit">充值购买</div>
      <div class="userPay-info">
        <h3>请您通过网银转账，或者到银行进行汇款，账号如下：</h3>
        <div class="userPay-info-name">
          <p><i class="el-icon-user-solid"></i>开户名称：青岛嘉智物流科技有限公司</p>
          <p><i class="el-icon-s-finance"></i>对公账号：1234 4321 1234 4321</p>
          <p><i class="el-icon-menu"></i>开户银行：中国银行青岛市分行</p>
          <div class="userPay-info-name-bank">
            <img src="../../../static/images/common/bank_logo.png" alt="">
          </div>
          <div class="userPay-info-name-btn">
            <el-button type="primary">联系客服</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "UserPay",
    data() {
      return {}
    }
  }
</script>

<style scoped>
  @import "coms/user.css"
</style>



// WEBPACK FOOTER //
// src/components/user/user_pay.vue